









































import path from 'path';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Route, RouteConfig } from 'vue-router';
import AppSidebarSingleItem from './AppSidebarSingleItem.vue';
import { translateRouteTitle } from '@/utils/permission';

export const showItem = (item: RouteConfig) => item.meta && !item.meta.hidden;

export const alwaysShowRoot = (item: RouteConfig) =>
  item.meta && item.meta.alwaysShow;

export const showingChildNumber = (item: RouteConfig) => {
  if (item.children) {
    const showingChildren = item.children.filter(
      item => !(item.meta && item.meta.hidden)
    );
    return showingChildren.length;
  }
  return 0;
};

export const getSingleItem = (item: RouteConfig) => {
  if (showingChildNumber(item) > 1) {
    return null;
  }
  if (item.children) {
    for (let child of item.children) {
      if (!child.meta || !child.meta.hidden) {
        return child;
      }
    }
  }
  return item;
};

export const isSingleItem = (item: RouteConfig) => {
  if (!alwaysShowRoot(item)) {
    const singleItem = getSingleItem(item);
    if (singleItem) {
      return true;
      // if (!singleItem.children) {
      //   return true;
      // }
    }
  }
  return false;
};

@Component({
  name: 'AppSidebarGroupItem',
  components: {
    AppSidebarSingleItem,
  },
})
export default class extends Vue {
  @Prop({ default: '/' }) private basePath!: string;
  @Prop({ required: true }) private item!: RouteConfig;
  @Prop({ default: false }) private isSubGroup!: boolean;

  get hasChildren() {
    return !this.isSubGroup && this.item.meta && this.item.meta.children;
  }

  get childrenItems() {
    return this.item.children || [];
  }

  private showItem(item: RouteConfig) {
    return showItem(item);
  }

  private getSingleItem(item: RouteConfig) {
    return getSingleItem(item) as RouteConfig;
  }

  private isSingleItem(item: RouteConfig) {
    return isSingleItem(item);
  }

  private resolvePath(basePath: string, subPath: string) {
    return path.resolve(basePath, subPath);
  }

  private translateRouteTitle(title: string) {
    return translateRouteTitle(this.$i18n, title);
  }
}
